import { ApartmentEntry, ApartmentStatus } from '../../types/config';

export const inventoryDataPisgat: ApartmentEntry[] = [
  {
    building: '1',
    number: 1,
    type: 'GA',
    floor: 0,
    rooms: 5,
    area: 119,
    balconyArea: 139,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_GA_select_floor0',
    nrId: 1,
    tourUrl: 'https://my.treedis.com/tour/ga',
    galleryType: 'galleryGA',
    galleryCount: 22,
    floorPlanImage: 'floorplanGA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 2,
    type: 'GAM1',
    floor: 0,
    rooms: 5,
    area: 119,
    balconyArea: 116,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_GAM1_select_floor0',
    nrId: 2,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanGAM1',
    hasVideo: false,
  },
  {
    building: '1',
    number: 3,
    type: 'A4',
    floor: 1,
    rooms: 5,
    area: 119,
    balconyArea: 19,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A4_select_floor1',
    nrId: 3,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 4,
    type: 'A4M',
    floor: 1,
    rooms: 5,
    area: 119,
    balconyArea: 19,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A4M_select_floor1',
    nrId: 4,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 5,
    type: 'B4M',
    floor: 1,
    rooms: 4,
    area: 95,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B4M_select_floor1',
    nrId: 5,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 6,
    type: 'B4',
    floor: 1,
    rooms: 4,
    area: 95,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B4_select_floor1',
    nrId: 6,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 7,
    type: 'A3',
    floor: 2,
    rooms: 5,
    area: 119,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A3_select_floor2',
    nrId: 7,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 8,
    type: 'A3M',
    floor: 2,
    rooms: 5,
    area: 119,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A3M_select_floor2',
    nrId: 8,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 9,
    type: 'B3M',
    floor: 2,
    rooms: 4,
    area: 95,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B3M_select_floor2',
    nrId: 9,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 10,
    type: 'B3',
    floor: 2,
    rooms: 4,
    area: 95,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B3_select_floor2',
    nrId: 10,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 11,
    type: 'A2',
    floor: 3,
    rooms: 5,
    area: 119,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A2_select_floor3',
    nrId: 11,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 12,
    type: 'A2M',
    floor: 3,
    rooms: 5,
    area: 119,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A2M_select_floor3',
    nrId: 12,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 13,
    type: 'B2M',
    floor: 3,
    rooms: 4,
    area: 95,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B2M_select_floor3',
    nrId: 13,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 14,
    type: 'B2',
    floor: 3,
    rooms: 4,
    area: 95,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B2_select_floor3',
    nrId: 14,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 15,
    type: 'A',
    floor: 4,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor4',
    nrId: 15,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 16,
    type: 'AM',
    floor: 4,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor4',
    nrId: 16,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 17,
    type: 'BM',
    floor: 4,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor4',
    nrId: 17,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 18,
    type: 'B',
    floor: 4,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor4',
    nrId: 18,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 19,
    type: 'A',
    floor: 5,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor5',
    nrId: 19,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 20,
    type: 'AM',
    floor: 5,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor5',
    nrId: 20,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 21,
    type: 'BM',
    floor: 5,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor5',
    nrId: 21,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 22,
    type: 'B',
    floor: 5,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor5',
    nrId: 22,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 23,
    type: 'A',
    floor: 6,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor6',
    nrId: 23,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 24,
    type: 'AM',
    floor: 6,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor6',
    nrId: 24,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 25,
    type: 'BM',
    floor: 6,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor6',
    nrId: 25,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 26,
    type: 'B',
    floor: 6,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor6',
    nrId: 26,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 27,
    type: 'A',
    floor: 7,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor7',
    nrId: 27,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 28,
    type: 'AM',
    floor: 7,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor7',
    nrId: 28,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 29,
    type: 'BM',
    floor: 7,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor7',
    nrId: 29,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 30,
    type: 'B',
    floor: 7,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor7',
    nrId: 30,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 31,
    type: 'A',
    floor: 8,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor8',
    nrId: 31,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 32,
    type: 'AM',
    floor: 8,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor8',
    nrId: 32,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 33,
    type: 'BM',
    floor: 8,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor8',
    nrId: 33,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 34,
    type: 'B',
    floor: 8,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor8',
    nrId: 34,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 35,
    type: 'A',
    floor: 9,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor9',
    nrId: 35,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 36,
    type: 'AM',
    floor: 9,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor9',
    nrId: 36,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 37,
    type: 'BM',
    floor: 9,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor9',
    nrId: 37,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 38,
    type: 'B',
    floor: 9,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor9',
    nrId: 38,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 39,
    type: 'A',
    floor: 10,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor10',
    nrId: 39,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 40,
    type: 'AM',
    floor: 10,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor10',
    nrId: 40,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 41,
    type: 'BM',
    floor: 10,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor10',
    nrId: 41,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 42,
    type: 'B',
    floor: 10,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor10',
    nrId: 42,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 43,
    type: 'A',
    floor: 11,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor11',
    nrId: 43,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 44,
    type: 'AM',
    floor: 11,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor11',
    nrId: 44,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 45,
    type: 'BM',
    floor: 11,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor11',
    nrId: 45,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 46,
    type: 'B',
    floor: 11,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor11',
    nrId: 46,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 47,
    type: 'A',
    floor: 12,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor12',
    nrId: 47,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 48,
    type: 'AM',
    floor: 12,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor12',
    nrId: 48,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 49,
    type: 'BM',
    floor: 12,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor12',
    nrId: 49,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 50,
    type: 'B',
    floor: 12,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor12',
    nrId: 50,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 51,
    type: 'A',
    floor: 13,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor13',
    nrId: 51,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 52,
    type: 'AM',
    floor: 13,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor13',
    nrId: 52,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 53,
    type: 'BM',
    floor: 13,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor13',
    nrId: 53,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 54,
    type: 'B',
    floor: 13,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor13',
    nrId: 54,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 55,
    type: 'A',
    floor: 14,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A_select_floor14',
    nrId: 55,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 56,
    type: 'AM',
    floor: 14,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_AM_select_floor14',
    nrId: 56,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 57,
    type: 'BM',
    floor: 14,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_BM_select_floor14',
    nrId: 57,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 58,
    type: 'B',
    floor: 14,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B_select_floor14',
    nrId: 58,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 59,
    type: 'A1',
    floor: 15,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A1_select_floor15',
    nrId: 59,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '1',
    number: 60,
    type: 'A1M',
    floor: 15,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A1M_select_floor15',
    nrId: 60,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 61,
    type: 'B1M',
    floor: 15,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B1M_select_floor15',
    nrId: 61,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '1',
    number: 62,
    type: 'B1',
    floor: 15,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B1_select_floor15',
    nrId: 62,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '1',
    number: 63,
    type: 'PHA',
    floor: 16,
    rooms: 5,
    area: 159,
    balconyArea: 102,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_PHA_select_floor16',
    nrId: 63,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanPHA',
    hasVideo: false,
  },
  {
    building: '1',
    number: 64,
    type: 'PHB',
    floor: 16,
    rooms: 5,
    area: 143,
    balconyArea: 75,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_PHB_select_floor16',
    nrId: 64,
    tourUrl: 'https://my.treedis.com/tour/phb',
    galleryType: 'galleryPHB',
    galleryCount: 14,
    floorPlanImage: 'floorplanPHB',
    hasVideo: true,
  },
  {
    building: '2',
    number: 1,
    type: 'GB',
    floor: 0,
    rooms: 4,
    area: 95,
    balconyArea: 128,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_GB_select_floor0',
    nrId: 65,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanGB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 2,
    type: 'GBM1',
    floor: 0,
    rooms: 4,
    area: 95,
    balconyArea: 118,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_GBM1_select_floor0',
    nrId: 66,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanGBM1',
    hasVideo: false,
  },
  {
    building: '2',
    number: 3,
    type: 'BA3',
    floor: 1,
    rooms: 4,
    area: 94,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA3_select_floor1',
    nrId: 67,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 4,
    type: 'BA3-M',
    floor: 1,
    rooms: 4,
    area: 94,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA3-M_select_floor1',
    nrId: 68,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 5,
    type: 'BB',
    floor: 1,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor1',
    nrId: 69,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 6,
    type: 'C3',
    floor: 1,
    rooms: 3,
    area: 79,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C3_select_floor1',
    nrId: 70,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 7,
    type: 'CA',
    floor: 1,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor1',
    nrId: 71,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 8,
    type: 'BA2',
    floor: 2,
    rooms: 4,
    area: 94,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA2_select_floor2',
    nrId: 72,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 9,
    type: 'BA2M',
    floor: 2,
    rooms: 4,
    area: 94,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA2M_select_floor2',
    nrId: 73,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 10,
    type: 'BB',
    floor: 2,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor2',
    nrId: 74,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 11,
    type: 'C2',
    floor: 2,
    rooms: 3,
    area: 79,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C2_select_floor2',
    nrId: 75,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 12,
    type: 'CA',
    floor: 2,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor2',
    nrId: 76,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 13,
    type: 'BA',
    floor: 3,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor3',
    nrId: 77,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 14,
    type: 'BAM',
    floor: 3,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor3',
    nrId: 78,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 15,
    type: 'BB',
    floor: 3,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor3',
    nrId: 79,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 16,
    type: 'C',
    floor: 3,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor3',
    nrId: 80,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 17,
    type: 'CA',
    floor: 3,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor3',
    nrId: 81,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 18,
    type: 'BA',
    floor: 4,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor4',
    nrId: 82,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 19,
    type: 'BAM',
    floor: 4,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor4',
    nrId: 83,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 20,
    type: 'BB',
    floor: 4,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor4',
    nrId: 84,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 21,
    type: 'C',
    floor: 4,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor4',
    nrId: 85,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 22,
    type: 'CA',
    floor: 4,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor4',
    nrId: 86,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 23,
    type: 'BA',
    floor: 5,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor5',
    nrId: 87,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 24,
    type: 'BAM',
    floor: 5,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor5',
    nrId: 88,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 25,
    type: 'BB',
    floor: 5,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor5',
    nrId: 89,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 26,
    type: 'C',
    floor: 5,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor5',
    nrId: 90,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 27,
    type: 'CA',
    floor: 5,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor5',
    nrId: 91,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 28,
    type: 'BA',
    floor: 6,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor6',
    nrId: 92,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 29,
    type: 'BAM',
    floor: 6,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor6',
    nrId: 93,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 30,
    type: 'BB',
    floor: 6,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor6',
    nrId: 94,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 31,
    type: 'C',
    floor: 6,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor6',
    nrId: 95,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 32,
    type: 'CA',
    floor: 6,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor6',
    nrId: 96,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 33,
    type: 'BA',
    floor: 7,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor7',
    nrId: 97,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 34,
    type: 'BAM',
    floor: 7,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor7',
    nrId: 98,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 35,
    type: 'BB',
    floor: 7,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor7',
    nrId: 99,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 36,
    type: 'C',
    floor: 7,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor7',
    nrId: 100,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: false,
  },
  {
    building: '2',
    number: 37,
    type: 'CA',
    floor: 7,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor7',
    nrId: 101,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 38,
    type: 'BA',
    floor: 8,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor8',
    nrId: 102,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 39,
    type: 'BAM',
    floor: 8,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor8',
    nrId: 103,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 40,
    type: 'BB',
    floor: 8,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor8',
    nrId: 104,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 41,
    type: 'C',
    floor: 8,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor8',
    nrId: 105,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 42,
    type: 'CA',
    floor: 8,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor8',
    nrId: 106,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 43,
    type: 'BA',
    floor: 9,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor9',
    nrId: 107,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 44,
    type: 'BAM',
    floor: 9,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor9',
    nrId: 108,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 45,
    type: 'BB',
    floor: 9,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor9',
    nrId: 109,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 46,
    type: 'C',
    floor: 9,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor9',
    nrId: 110,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 47,
    type: 'CA',
    floor: 9,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor9',
    nrId: 111,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 48,
    type: 'BA',
    floor: 10,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor10',
    nrId: 112,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 49,
    type: 'BAM',
    floor: 10,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor10',
    nrId: 113,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 50,
    type: 'BB',
    floor: 10,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor10',
    nrId: 114,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 51,
    type: 'C',
    floor: 10,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor10',
    nrId: 115,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 52,
    type: 'CA',
    floor: 10,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor10',
    nrId: 116,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 53,
    type: 'BA',
    floor: 11,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor11',
    nrId: 117,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 54,
    type: 'BAM',
    floor: 11,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor11',
    nrId: 118,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 55,
    type: 'BB',
    floor: 11,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor11',
    nrId: 119,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 56,
    type: 'C',
    floor: 11,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor11',
    nrId: 120,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 57,
    type: 'CA',
    floor: 11,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor11',
    nrId: 121,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 58,
    type: 'BA',
    floor: 12,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor12',
    nrId: 122,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 59,
    type: 'BAM',
    floor: 12,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor12',
    nrId: 123,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 60,
    type: 'BB',
    floor: 12,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor12',
    nrId: 124,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 61,
    type: 'C',
    floor: 12,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor12',
    nrId: 125,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 62,
    type: 'CA',
    floor: 12,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor12',
    nrId: 126,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 63,
    type: 'BA',
    floor: 13,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor13',
    nrId: 127,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 64,
    type: 'BAM',
    floor: 13,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor13',
    nrId: 128,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 65,
    type: 'BB',
    floor: 13,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor13',
    nrId: 129,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 66,
    type: 'C',
    floor: 13,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor13',
    nrId: 130,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 67,
    type: 'CA',
    floor: 13,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor13',
    nrId: 131,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 68,
    type: 'BA',
    floor: 14,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA_select_floor14',
    nrId: 132,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 69,
    type: 'BAM',
    floor: 14,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BAM_select_floor14',
    nrId: 133,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 70,
    type: 'BB',
    floor: 14,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB_select_floor14',
    nrId: 134,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 71,
    type: 'C',
    floor: 14,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor14',
    nrId: 135,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 72,
    type: 'CA',
    floor: 14,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA_select_floor14',
    nrId: 136,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 73,
    type: 'BA1',
    floor: 15,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA1_select_floor15',
    nrId: 137,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 74,
    type: 'BA1M',
    floor: 15,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BA1M_select_floor15',
    nrId: 138,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '2',
    number: 75,
    type: 'BB1',
    floor: 15,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_BB1_select_floor15',
    nrId: 139,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '2',
    number: 76,
    type: 'C1',
    floor: 15,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C1_select_floor15',
    nrId: 140,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '2',
    number: 77,
    type: 'CA1',
    floor: 15,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_CA1_select_floor15',
    nrId: 141,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '2',
    number: 78,
    type: 'PHC',
    floor: 16,
    rooms: 5,
    area: 152,
    balconyArea: 78,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_PHC_select_floor16',
    nrId: 142,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanPHC',
    hasVideo: false,
  },
  {
    building: '2',
    number: 79,
    type: 'PHD',
    floor: 16,
    rooms: 5,
    area: 161,
    balconyArea: 107,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_PHD_select_floor16',
    nrId: 143,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanPHD',
    hasVideo: false,
  },
  {
    building: '3',
    number: 1,
    type: 'GA',
    floor: 0,
    rooms: 5,
    area: 119,
    balconyArea: 139,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_GA_select_floor0',
    nrId: 144,
    tourUrl: 'https://my.treedis.com/tour/ga',
    galleryType: 'galleryGA',
    galleryCount: 22,
    floorPlanImage: 'floorplanGA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 2,
    type: 'GAM1',
    floor: 0,
    rooms: 5,
    area: 119,
    balconyArea: 116,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_GAM1_select_floor0',
    nrId: 145,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanGAM1',
    hasVideo: false,
  },
  {
    building: '3',
    number: 3,
    type: 'A4',
    floor: 1,
    rooms: 5,
    area: 119,
    balconyArea: 19,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A4_select_floor1',
    nrId: 146,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 4,
    type: 'A4M',
    floor: 1,
    rooms: 5,
    area: 119,
    balconyArea: 19,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A4M_select_floor1',
    nrId: 147,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 5,
    type: 'B4M',
    floor: 1,
    rooms: 4,
    area: 95,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B4M_select_floor1',
    nrId: 148,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 6,
    type: 'B4',
    floor: 1,
    rooms: 4,
    area: 95,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B4_select_floor1',
    nrId: 149,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 7,
    type: 'A3',
    floor: 2,
    rooms: 5,
    area: 119,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A3_select_floor2',
    nrId: 150,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 8,
    type: 'A3M',
    floor: 2,
    rooms: 5,
    area: 119,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A3M_select_floor2',
    nrId: 151,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 9,
    type: 'B3M',
    floor: 2,
    rooms: 4,
    area: 95,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B3M_select_floor2',
    nrId: 152,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 10,
    type: 'B3',
    floor: 2,
    rooms: 4,
    area: 95,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B3_select_floor2',
    nrId: 153,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 11,
    type: 'A2',
    floor: 3,
    rooms: 5,
    area: 119,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A2_select_floor3',
    nrId: 154,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 12,
    type: 'A2M',
    floor: 3,
    rooms: 5,
    area: 119,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A2M_select_floor3',
    nrId: 155,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 13,
    type: 'B2M',
    floor: 3,
    rooms: 4,
    area: 95,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B2M_select_floor3',
    nrId: 156,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 14,
    type: 'B2',
    floor: 3,
    rooms: 4,
    area: 95,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B2_select_floor3',
    nrId: 157,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 15,
    type: 'A',
    floor: 4,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor4',
    nrId: 158,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 16,
    type: 'AM',
    floor: 4,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor4',
    nrId: 159,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 17,
    type: 'BM',
    floor: 4,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor4',
    nrId: 160,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 18,
    type: 'B',
    floor: 4,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor4',
    nrId: 161,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 19,
    type: 'A',
    floor: 5,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor5',
    nrId: 162,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 20,
    type: 'AM',
    floor: 5,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor5',
    nrId: 163,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 21,
    type: 'BM',
    floor: 5,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor5',
    nrId: 164,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 22,
    type: 'B',
    floor: 5,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor5',
    nrId: 165,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 23,
    type: 'A',
    floor: 6,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor6',
    nrId: 166,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 24,
    type: 'AM',
    floor: 6,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor6',
    nrId: 167,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 25,
    type: 'BM',
    floor: 6,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor6',
    nrId: 168,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 26,
    type: 'B',
    floor: 6,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor6',
    nrId: 169,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 27,
    type: 'A',
    floor: 7,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor7',
    nrId: 170,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 28,
    type: 'AM',
    floor: 7,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor7',
    nrId: 171,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 29,
    type: 'BM',
    floor: 7,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor7',
    nrId: 172,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 30,
    type: 'B',
    floor: 7,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor7',
    nrId: 173,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 31,
    type: 'A',
    floor: 8,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor8',
    nrId: 174,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 32,
    type: 'AM',
    floor: 8,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor8',
    nrId: 175,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 33,
    type: 'BM',
    floor: 8,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor8',
    nrId: 176,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 34,
    type: 'B',
    floor: 8,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor8',
    nrId: 177,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 35,
    type: 'A',
    floor: 9,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor9',
    nrId: 178,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 36,
    type: 'AM',
    floor: 9,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor9',
    nrId: 179,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 37,
    type: 'BM',
    floor: 9,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor9',
    nrId: 180,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 38,
    type: 'B',
    floor: 9,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor9',
    nrId: 181,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 39,
    type: 'A',
    floor: 10,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor10',
    nrId: 182,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 40,
    type: 'AM',
    floor: 10,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor10',
    nrId: 183,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 41,
    type: 'BM',
    floor: 10,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor10',
    nrId: 184,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 42,
    type: 'B',
    floor: 10,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor10',
    nrId: 185,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 43,
    type: 'A',
    floor: 11,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor11',
    nrId: 186,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 44,
    type: 'AM',
    floor: 11,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor11',
    nrId: 187,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 45,
    type: 'BM',
    floor: 11,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor11',
    nrId: 188,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 46,
    type: 'B',
    floor: 11,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor11',
    nrId: 189,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 47,
    type: 'A',
    floor: 12,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor12',
    nrId: 190,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 48,
    type: 'AM',
    floor: 12,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor12',
    nrId: 191,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 49,
    type: 'BM',
    floor: 12,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor12',
    nrId: 192,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 50,
    type: 'B',
    floor: 12,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor12',
    nrId: 193,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 51,
    type: 'A',
    floor: 13,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor13',
    nrId: 194,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 52,
    type: 'AM',
    floor: 13,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor13',
    nrId: 195,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 53,
    type: 'BM',
    floor: 13,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor13',
    nrId: 196,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 54,
    type: 'B',
    floor: 13,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor13',
    nrId: 197,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 55,
    type: 'A',
    floor: 14,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A_select_floor14',
    nrId: 198,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 56,
    type: 'AM',
    floor: 14,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_AM_select_floor14',
    nrId: 199,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 57,
    type: 'BM',
    floor: 14,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_BM_select_floor14',
    nrId: 200,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 58,
    type: 'B',
    floor: 14,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B_select_floor14',
    nrId: 201,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 59,
    type: 'A1',
    floor: 15,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A1_select_floor15',
    nrId: 202,
    tourUrl: 'https://my.treedis.com/tour/a-41e1a743',
    galleryType: 'galleryA',
    galleryCount: 18,
    floorPlanImage: 'floorplanA',
    hasVideo: true,
  },
  {
    building: '3',
    number: 60,
    type: 'A1M',
    floor: 15,
    rooms: 5,
    area: 119,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_A1M_select_floor15',
    nrId: 203,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanAM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 61,
    type: 'B1M',
    floor: 15,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B1M_select_floor15',
    nrId: 204,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBM',
    hasVideo: false,
  },
  {
    building: '3',
    number: 62,
    type: 'B1',
    floor: 15,
    rooms: 4,
    area: 95,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_B1_select_floor15',
    nrId: 205,
    tourUrl: 'https://my.treedis.com/tour/b-2de13287',
    galleryType: 'galleryB',
    galleryCount: 16,
    floorPlanImage: 'floorplanB',
    hasVideo: true,
  },
  {
    building: '3',
    number: 63,
    type: 'PHA',
    floor: 16,
    rooms: 5,
    area: 159,
    balconyArea: 102,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_PHA_select_floor16',
    nrId: 206,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanPHA',
    hasVideo: false,
  },
  {
    building: '3',
    number: 64,
    type: 'PHB',
    floor: 16,
    rooms: 5,
    area: 143,
    balconyArea: 75,
    status: ApartmentStatus.Available,
    liked: false,
    id: '3_PHB_select_floor16',
    nrId: 207,
    tourUrl: 'https://my.treedis.com/tour/phb',
    galleryType: 'galleryPHB',
    galleryCount: 14,
    floorPlanImage: 'floorplanPHB',
    hasVideo: true,
  },
  {
    building: '4',
    number: 1,
    type: 'GB',
    floor: 0,
    rooms: 4,
    area: 95,
    balconyArea: 128,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_GB_select_floor0',
    nrId: 208,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanGB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 2,
    type: 'GBM1',
    floor: 0,
    rooms: 4,
    area: 95,
    balconyArea: 118,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_GBM1_select_floor0',
    nrId: 209,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanGBM1',
    hasVideo: false,
  },
  {
    building: '4',
    number: 3,
    type: 'BA3',
    floor: 1,
    rooms: 4,
    area: 94,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA3_select_floor1',
    nrId: 210,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 4,
    type: 'BA3-M',
    floor: 1,
    rooms: 4,
    area: 94,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA3-M_select_floor1',
    nrId: 211,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 5,
    type: 'BB',
    floor: 1,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor1',
    nrId: 212,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 6,
    type: 'C3',
    floor: 1,
    rooms: 3,
    area: 79,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C3_select_floor1',
    nrId: 213,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 7,
    type: 'CA',
    floor: 1,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor1',
    nrId: 214,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 8,
    type: 'BA2',
    floor: 2,
    rooms: 4,
    area: 94,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA2_select_floor2',
    nrId: 215,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 9,
    type: 'BA2M',
    floor: 2,
    rooms: 4,
    area: 94,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA2M_select_floor2',
    nrId: 216,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 10,
    type: 'BB',
    floor: 2,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor2',
    nrId: 217,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 11,
    type: 'C2',
    floor: 2,
    rooms: 3,
    area: 79,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C2_select_floor2',
    nrId: 218,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 12,
    type: 'CA',
    floor: 2,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor2',
    nrId: 219,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 13,
    type: 'BA',
    floor: 3,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor3',
    nrId: 220,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 14,
    type: 'BAM',
    floor: 3,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor3',
    nrId: 221,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 15,
    type: 'BB',
    floor: 3,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor3',
    nrId: 222,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 16,
    type: 'C',
    floor: 3,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor3',
    nrId: 223,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 17,
    type: 'CA',
    floor: 3,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor3',
    nrId: 224,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 18,
    type: 'BA',
    floor: 4,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor4',
    nrId: 225,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 19,
    type: 'BAM',
    floor: 4,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor4',
    nrId: 226,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 20,
    type: 'BB',
    floor: 4,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor4',
    nrId: 227,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 21,
    type: 'C',
    floor: 4,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor4',
    nrId: 228,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 22,
    type: 'CA',
    floor: 4,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor4',
    nrId: 229,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 23,
    type: 'BA',
    floor: 5,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor5',
    nrId: 230,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 24,
    type: 'BAM',
    floor: 5,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor5',
    nrId: 231,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 25,
    type: 'BB',
    floor: 5,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor5',
    nrId: 232,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 26,
    type: 'C',
    floor: 5,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor5',
    nrId: 233,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 27,
    type: 'CA',
    floor: 5,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor5',
    nrId: 234,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 28,
    type: 'BA',
    floor: 6,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor6',
    nrId: 235,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 29,
    type: 'BAM',
    floor: 6,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor6',
    nrId: 236,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 30,
    type: 'BB',
    floor: 6,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor6',
    nrId: 237,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 31,
    type: 'C',
    floor: 6,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor6',
    nrId: 238,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 32,
    type: 'CA',
    floor: 6,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor6',
    nrId: 239,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 33,
    type: 'BA',
    floor: 7,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor7',
    nrId: 240,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 34,
    type: 'BAM',
    floor: 7,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor7',
    nrId: 241,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 35,
    type: 'BB',
    floor: 7,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor7',
    nrId: 242,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 36,
    type: 'C',
    floor: 7,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor7',
    nrId: 243,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: false,
  },
  {
    building: '4',
    number: 37,
    type: 'CA',
    floor: 7,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor7',
    nrId: 244,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 38,
    type: 'BA',
    floor: 8,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor8',
    nrId: 245,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 39,
    type: 'BAM',
    floor: 8,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor8',
    nrId: 246,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 40,
    type: 'BB',
    floor: 8,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor8',
    nrId: 247,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 41,
    type: 'C',
    floor: 8,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor8',
    nrId: 248,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 42,
    type: 'CA',
    floor: 8,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor8',
    nrId: 249,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 43,
    type: 'BA',
    floor: 9,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor9',
    nrId: 250,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 44,
    type: 'BAM',
    floor: 9,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor9',
    nrId: 251,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 45,
    type: 'BB',
    floor: 9,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor9',
    nrId: 252,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 46,
    type: 'C',
    floor: 9,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor9',
    nrId: 253,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 47,
    type: 'CA',
    floor: 9,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor9',
    nrId: 254,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 48,
    type: 'BA',
    floor: 10,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor10',
    nrId: 255,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 49,
    type: 'BAM',
    floor: 10,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor10',
    nrId: 256,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 50,
    type: 'BB',
    floor: 10,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor10',
    nrId: 257,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 51,
    type: 'C',
    floor: 10,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor10',
    nrId: 258,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 52,
    type: 'CA',
    floor: 10,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor10',
    nrId: 259,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 53,
    type: 'BA',
    floor: 11,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor11',
    nrId: 260,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 54,
    type: 'BAM',
    floor: 11,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor11',
    nrId: 261,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 55,
    type: 'BB',
    floor: 11,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor11',
    nrId: 262,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 56,
    type: 'C',
    floor: 11,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor11',
    nrId: 263,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 57,
    type: 'CA',
    floor: 11,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor11',
    nrId: 264,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 58,
    type: 'BA',
    floor: 12,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor12',
    nrId: 265,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 59,
    type: 'BAM',
    floor: 12,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor12',
    nrId: 266,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 60,
    type: 'BB',
    floor: 12,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor12',
    nrId: 267,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 61,
    type: 'C',
    floor: 12,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor12',
    nrId: 268,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 62,
    type: 'CA',
    floor: 12,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor12',
    nrId: 269,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 63,
    type: 'BA',
    floor: 13,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor13',
    nrId: 270,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 64,
    type: 'BAM',
    floor: 13,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor13',
    nrId: 271,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 65,
    type: 'BB',
    floor: 13,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor13',
    nrId: 272,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 66,
    type: 'C',
    floor: 13,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor13',
    nrId: 273,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 67,
    type: 'CA',
    floor: 13,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor13',
    nrId: 274,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 68,
    type: 'BA',
    floor: 14,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA_select_floor14',
    nrId: 275,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 69,
    type: 'BAM',
    floor: 14,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BAM_select_floor14',
    nrId: 276,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 70,
    type: 'BB',
    floor: 14,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB_select_floor14',
    nrId: 277,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 71,
    type: 'C',
    floor: 14,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C_select_floor14',
    nrId: 278,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 72,
    type: 'CA',
    floor: 14,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA_select_floor14',
    nrId: 279,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 73,
    type: 'BA1',
    floor: 15,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA1_select_floor15',
    nrId: 280,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 74,
    type: 'BA1M',
    floor: 15,
    rooms: 4,
    area: 94,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BA1M_select_floor15',
    nrId: 281,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBAM',
    hasVideo: false,
  },
  {
    building: '4',
    number: 75,
    type: 'BB1',
    floor: 15,
    rooms: 4,
    area: 95,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_BB1_select_floor15',
    nrId: 282,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanBB',
    hasVideo: false,
  },
  {
    building: '4',
    number: 76,
    type: 'C1',
    floor: 15,
    rooms: 3,
    area: 79,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_C1_select_floor15',
    nrId: 283,
    tourUrl: 'https://my.treedis.com/tour/c-7349a364',
    galleryType: 'galleryC',
    galleryCount: 9,
    floorPlanImage: 'floorplanC',
    hasVideo: true,
  },
  {
    building: '4',
    number: 77,
    type: 'CA1',
    floor: 15,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_CA1_select_floor15',
    nrId: 284,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanCA',
    hasVideo: false,
  },
  {
    building: '4',
    number: 78,
    type: 'PHC',
    floor: 16,
    rooms: 5,
    area: 152,
    balconyArea: 78,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_PHC_select_floor16',
    nrId: 285,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanPHC',
    hasVideo: false,
  },
  {
    building: '4',
    number: 79,
    type: 'PHD',
    floor: 16,
    rooms: 5,
    area: 161,
    balconyArea: 107,
    status: ApartmentStatus.Available,
    liked: false,
    id: '4_PHD_select_floor16',
    nrId: 286,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: 'floorplanPHD',
    hasVideo: false,
  },
];
